import React, { useReducer } from 'react'
import { Autocomplete, TextField } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress';
import timeoutList from './TimeoutList';
import { lockedReducer } from './reducers';

const MegaAutoComplete = ({ multiple = false, value, onChange, noOptionsText, timeoutUrl, timeoutParam, label, replace = {} }) => {

    const [state, setState] = useReducer(lockedReducer, {
        data: [],
        smallLoading: false
    })

    return (
        <Autocomplete
            multiple={multiple}
            sx={{ flex: 1 }}
            id={'megaautocompletebox'}
            value={value}
            options={state.data.filter(each => multiple ? !value?.map(e => e.id).includes(each.id) : value?.id !== each.id)}
            onChange={(e, selectedData) => onChange(selectedData)}
            autoHighlight
            handleHomeEndKeys
            clearText='Limpar'
            noOptionsText={noOptionsText || 'Digite para pesquisar'}
            loading={state.smallLoading}
            ChipProps={{ size: 'small' }}
            filterSelectedOptions
            onOpen={() => state.data.length === 0 && timeoutList('', timeoutUrl, 'data', timeoutParam || 'name', setState)}
            onInputChange={(e, v) => { e?.type === 'change' && timeoutList(v, timeoutUrl, 'data', timeoutParam || 'name', setState) }}
            renderInput={(params) =>
                <TextField
                    {...params}
                    id={'autocompleteinput'}
                    type="text"
                    sx={{ backgroundColor: 'white' }}
                    label={label || ''}
                    size="small"
                    fullWidth={true}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {state.smallLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            }
            {...replace}
        />
    )
}

export default MegaAutoComplete